import {createRouter, createWebHistory} from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: {
            name: "login"
        }
    },
    {
        path: '/index.html',
        redirect: {
            name: "login"
        }
    },
    {
        path: '/iduy-login',
        name: 'iduy-login',
        component: () => import('./pages/LoginIdUy.vue'),
    },
    {
        path: '/iduy-logout',
        name: 'iduy-logout',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue'),
    },
    /* {
        path: '/datospersonales',
        name: 'Datos personales',
        component: () => import('./pages/DatosPersonales.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Datos Personales' }],
        },
    }, */
    {
        path: '/puntomovil',
        name: 'Punto móvil',
        component: () => import('./pages/Movil.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Comedor' }],
        },
    },
    {
        path: '/multiplicador',
        name: 'Factor multiplicador',
        component: () => import('./pages/Multiplicador.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Factor multiplicador' }],
        },
    },
    {
        path: '/entregaqr',
        name: 'Entrega QR',
        component: () => import('./pages/EntregaQR.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Entrega por código QR' }],
        },
    },
    {
        path: '/entregacodigo',
        name: 'Entrega código',
        component: () => import('./pages/EntregaCodigo.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Entrega por código alfanumérico' }],
        },
    },
    {
        path: '/entregaexcepcion',
        name: 'Entrega excepcional',
        component: () => import('./pages/EntregaExcepcion.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Entrega Excepcional' }],
        },
    },
    {
        path: '/remitos',
        name: 'Remitos',
        component: () => import('./pages/Remitos.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Remitos entrada / salida de viandas' }],
        },
    },
    {
        path: '/reportediario',
        name: 'Reporte Diario',
        component: () => import('./pages/ReporteDiario.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Reporte Diario' }],
        },
    },
    {
        path: '/reporteremitos',
        name: 'Remitos del día',
        component: () => import('./pages/ReporteRemitos.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Remitos del día' }],
        },
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue'),
        props: true
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue'),
        props: true
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue'),
        props: true
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/offline',
        name: 'offline',
        component: () => import('./pages/Offline.vue'),
        props: true
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

export default router;